import {Download} from '@icons/index';
import {Button, Stack} from '@mui/material';
import ClientsContractsTable from '@screens/admin/clients/contracts/ClientsContracts.table';
import {clientsContractsService} from '@store/clients/contracts';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

const ClientsContractsTab = () => {

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [CSVLoading, setCSVLoading] = useState(false);

  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsContractsService.getClientsContractsCSV().subscribe({
      next: () => {
        setCSVLoading(false);
      },
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  };

  return (
    <>
      <Stack flex={1} width="100%" spacing={2} mt="-35px">
        <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined" color="primary"
            disabled={CSVLoading}
            onClick={handleExportCSV}
            startIcon={<Download/>}>
            {t('global.exportCSV')}
          </Button>
        </Stack>
        <Stack flex={1}>
          <ClientsContractsTable/>
        </Stack>
      </Stack>
      <Outlet/>
    </>
  );
};

export default ClientsContractsTab;
